import { ReturnTypes } from "@sprycore/spry-api-client"
import * as EnumTypes from "./EnumTypes"

export type GetStateResult = ReturnTypes.CampaignState & {
    isOpen: boolean
    isClosed: boolean
    isSuspended: boolean
    isRedemptionOnly: boolean
    isComingSoon: boolean
}

export function getResultFromState(state: EnumTypes.ValidCampaignState, metadata: any): GetStateResult {
    return {
        state,
        metadata,
        isOpen: state === "open",
        isClosed: state === "closed",
        isSuspended: state === "suspended",
        isRedemptionOnly: state === "redemptiononly",
        isComingSoon: state === "comingsoon"
    }
}